/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.analytics.rpc.LeadGenerationRpc
 */
import * as References from './LeadGenerationRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerMutation } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.analytics.rpc.LeadGenerationRpc#createLeadContact
 */
export const CREATE_LEAD_CONTACT_MUTATION_FIELD_NAME =
  'com_hubspot_marketplace_analytics_rpc_LeadGenerationRpc_createLeadContact';
export const CREATE_LEAD_CONTACT_MUTATION: RegisteredQuery<
  'result',
  References.CreateLeadContactRequestType,
  References.CreateLeadContactResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: CREATE_LEAD_CONTACT_MUTATION_FIELD_NAME,
  args: ['listingId', 'action'],
  fetcher(
    request: References.CreateLeadContactRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.CreateLeadContactResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.createLeadContactRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
